module.exports = __webpack_public_path__ + "img/StrongBack.5de53bd4.png";